export default "__VITE_ASSET__1439898e__"